import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const Home = lazy(() => import("./pages/Home"));
const News = lazy(() => import("./pages/News"));
const NewsSinglePost = lazy(() => import("./pages/NewsSinglePost"));
const SearchResults = lazy(() => import("./pages/SearchResults"));
const Page404 = lazy(() => import("./pages/404"));
const UserInterface = lazy(() => import("./pages/UserInterface"));

function App() {
  return (
    <Router>
      <Suspense
        fallback={
          <div className="app-route-loading" role="status" aria-live="polite">
            Seite wird geladen...
          </div>
        }
      >
        <Switch>
          <Route
            exact
            path={`${process.env.PUBLIC_URL + "/"}`}
            component={Home}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL + "/news"}`}
            component={News}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL + "/news-single-post"}`}
            component={NewsSinglePost}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL + "/search-results"}`}
            component={SearchResults}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL + "/ui"}`}
            component={UserInterface}
          />
          <Route exact component={Page404} />
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
